<template>
  <v-card color="grey lighten-3" height="100%" flat>
    <v-card class="pa-6 mx-auto" max-width="1000">
      <h1 :style="`color: ${$vuetify.theme.themes.light.primary}`">
        {{ $translate('REGISTER_PRIVACY_STATEMENT') }}
      </h1>
      <p v-html="privacyStatement" />
    </v-card>
  </v-card>
</template>

<script>
export default {
  computed: {
    privacyStatement() {
      return this.$store.getters['Account/privacyStatement'];
    },
  },
  created() {
    // hide the header and footer
    this.$store.commit('setHideHeaderAndFooter', true);
  },
  beforeDestroy() {
    // show the header and footer if you leave the page
    this.$store.commit('setHideHeaderAndFooter', false);
  },
};
</script>
